import React, { ReactNode } from 'react'
import { assignAndRemoveTagActionData, ChatbotStepActionData } from '../../../../models/flowBuilderTypes'
import { Grid, Typography } from '@mui/material';
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../assets/styles/global.module.scss";
import { ACTION_TYPE_NAME } from '../flowBuilderConstants';
import { renderThreadTagChip } from '../../../../pages/ruleBasedInbox/renderUtils';

interface AssignAndRemoveTagNodeProps {
    id: string, 
    data: ChatbotStepActionData<assignAndRemoveTagActionData>
} 

const AssignAndRemoveTagNode: React.FC<AssignAndRemoveTagNodeProps> = (props) => {
    
    const {id, data} = props;

    const getTitleAndDescriptionObj = (title: string, description: string, flagShowTagChip?: boolean, tagColor?: string | null) => {
        return {
            title: title,
            description: flagShowTagChip ? renderThreadTagChip(description, tagColor, { isOption: true }) : description
        }
    }

    const getSaveAndRemoveContactTitleAndDescription = () => {
        if(data?.action_type?.action_type_name == ACTION_TYPE_NAME["ASSIGN_TAG"]){
            if(data?.action_data?.ticket_tag_id){
                return getTitleAndDescriptionObj("Assign Tag", data?.action_data?.ticket_tag_name, true,  data?.action_data?.ticket_tag_color);
            } else {
                return getTitleAndDescriptionObj("Assign Tag", "Please configure tag");
            }
        } else {
            if(data?.action_data?.ticket_tag_id){
                return getTitleAndDescriptionObj("Remove Tag", data?.action_data?.ticket_tag_name, true, data?.action_data?.ticket_tag_color);
            } else {
                return getTitleAndDescriptionObj("Remove Tag", "Please configure tag");
            }
        }
    }
    
    return (
        <>
            <Grid item>
                <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`}>
                    <Grid item>
                        <Typography className={formStyles.dataSavedTextStyle}>
                            {getSaveAndRemoveContactTitleAndDescription()?.title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={formStyles.dataSavedValueStyle}>
                            {getSaveAndRemoveContactTitleAndDescription()?.description}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AssignAndRemoveTagNode
